{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "custom_component_config",
  "type": "object",
  "required": ["component_id", "inputs"],
  "properties": {
    "component_id": {
      "type": "string",
      "enum": ["echarts-chart", "sequence-series-chart"]
    },
    "preset": {
      "type": "string"
    },
    "inputs": {
      "type": "object",
      "additionalProperties": true
    }
  },
  "additionalProperties": false,
  "if": {
    "properties": {
      "component_id": { "const": "echarts-chart" }
    }
  },
  "then": {
    "properties": {
      "inputs": {
        "type": "object",
        "properties": {
          "height": { "type": "number", "minimum": 50 },
          "options": { "$ref": "#/$defs/echarts_option" }
        },
        "additionalProperties": true
      }
    }
  },
  "$defs": {
    "echarts_option": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "grid": { "$ref": "#/$defs/grid" },
        "xAxis": {
          "oneOf": [
            { "$ref": "#/$defs/axis" },
            { "type": "array", "items": { "$ref": "#/$defs/axis" } }
          ]
        },
        "yAxis": {
          "oneOf": [
            { "$ref": "#/$defs/axis" },
            { "type": "array", "items": { "$ref": "#/$defs/axis" } }
          ]
        },
        "tooltip": { "$ref": "#/$defs/tooltip" },
        "legend": { "$ref": "#/$defs/legend" },
        "color": {
          "type": "array",
          "items": { "type": "string" }
        },
        "series": {
          "type": "array",
          "items": { "$ref": "#/$defs/series_item" }
        },
        "animation": { "type": "boolean" },
        "animationDuration": { "type": "number" }
      }
    },
    "grid": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "left": {},
        "right": {},
        "top": {},
        "bottom": {},
        "containLabel": { "type": "boolean" },
        "show": { "type": "boolean" },
        "backgroundColor": { "type": "string" },
        "borderColor": { "type": "string" },
        "borderWidth": { "type": "number" }
      }
    },
    "axis": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "type": {
          "type": "string",
          "enum": ["value", "category", "time", "log"]
        },
        "name": { "type": "string" },
        "nameLocation": {
          "type": "string",
          "enum": ["start", "middle", "center", "end"]
        },
        "nameTextStyle": { "$ref": "#/$defs/text_style" },
        "nameGap": { "type": "number" },
        "min": {},
        "max": {},
        "data": { "type": "array" },
        "show": { "type": "boolean" },
        "inverse": { "type": "boolean" },
        "boundaryGap": {},
        "splitLine": { "$ref": "#/$defs/line_style_wrapper" },
        "axisLine": { "$ref": "#/$defs/line_style_wrapper" },
        "axisTick": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "show": { "type": "boolean" }
          }
        },
        "axisLabel": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "show": { "type": "boolean" },
            "rotate": { "type": "number" },
            "formatter": { "type": "string" },
            "fontSize": { "type": "number" },
            "color": { "type": "string" }
          }
        },
        "interval": { "type": "number" }
      }
    },
    "tooltip": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "show": { "type": "boolean" },
        "trigger": {
          "type": "string",
          "enum": ["item", "axis", "none"]
        },
        "axisPointer": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "type": {
              "type": "string",
              "enum": ["line", "shadow", "cross", "none"]
            }
          }
        },
        "formatter": { "type": "string" }
      }
    },
    "legend": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "show": { "type": "boolean" },
        "data": { "type": "array", "items": { "type": "string" } },
        "orient": {
          "type": "string",
          "enum": ["horizontal", "vertical"]
        },
        "left": {},
        "top": {},
        "right": {},
        "bottom": {},
        "textStyle": { "$ref": "#/$defs/text_style" }
      }
    },
    "series_item": {
      "type": "object",
      "required": ["type"],
      "additionalProperties": true,
      "properties": {
        "type": {
          "type": "string",
          "enum": ["bar", "line", "scatter"]
        },
        "name": { "type": "string" },
        "data": { "type": "array" },
        "stack": { "type": "string" },
        "smooth": { "type": "boolean" },
        "areaStyle": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "color": { "type": "string" },
            "opacity": { "type": "number" }
          }
        },
        "itemStyle": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "color": { "type": "string" },
            "borderColor": { "type": "string" },
            "borderWidth": { "type": "number" },
            "borderRadius": {},
            "opacity": { "type": "number" }
          }
        },
        "lineStyle": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "color": { "type": "string" },
            "width": { "type": "number" },
            "type": {
              "type": "string",
              "enum": ["solid", "dashed", "dotted"]
            }
          }
        },
        "label": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "show": { "type": "boolean" },
            "position": {
              "type": "string",
              "enum": ["top", "bottom", "left", "right", "inside", "insideTop", "insideBottom"]
            },
            "formatter": { "type": "string" },
            "fontSize": { "type": "number" },
            "color": { "type": "string" }
          }
        },
        "markLine": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "silent": { "type": "boolean" },
            "symbol": {},
            "lineStyle": {
              "type": "object",
              "additionalProperties": true,
              "properties": {
                "color": { "type": "string" },
                "type": {
                  "type": "string",
                  "enum": ["solid", "dashed", "dotted"]
                }
              }
            },
            "data": { "type": "array" },
            "label": {
              "type": "object",
              "additionalProperties": true,
              "properties": {
                "show": { "type": "boolean" },
                "formatter": { "type": "string" }
              }
            }
          }
        },
        "markPoint": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "symbol": { "type": "string" },
            "symbolSize": { "type": "number" },
            "data": { "type": "array" },
            "label": {
              "type": "object",
              "additionalProperties": true,
              "properties": {
                "show": { "type": "boolean" },
                "formatter": { "type": "string" }
              }
            },
            "itemStyle": {
              "type": "object",
              "additionalProperties": true,
              "properties": {
                "color": { "type": "string" }
              }
            }
          }
        },
        "barWidth": {},
        "barGap": { "type": "string" },
        "showSymbol": { "type": "boolean" },
        "symbolSize": { "type": "number" },
        "symbol": { "type": "string" }
      }
    },
    "text_style": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "color": { "type": "string" },
        "fontSize": { "type": "number" },
        "fontWeight": {},
        "fontFamily": { "type": "string" }
      }
    },
    "line_style_wrapper": {
      "type": "object",
      "additionalProperties": true,
      "properties": {
        "show": { "type": "boolean" },
        "lineStyle": {
          "type": "object",
          "additionalProperties": true,
          "properties": {
            "color": { "type": "string" },
            "width": { "type": "number" },
            "type": {
              "type": "string",
              "enum": ["solid", "dashed", "dotted"]
            }
          }
        }
      }
    }
  }
}
